import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SplashScreen } from './components/splash/SplashScreen';
import { OnboardingFlow } from './components/onboarding/OnboardingFlow';
import { HomePage } from './pages/HomePage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { TrajetPage } from './pages/TrajetPage';
import { InstallPrompt } from './components/layout/InstallPrompt';
import { CookieBanner } from './components/layout/CookieBanner';
import { Footer } from './components/layout/Footer';
const ONBOARDED_KEY = 'idanroh-onboarded';

type Phase = 'splash' | 'onboarding' | 'app';

export function App() {
  const [phase, setPhase] = useState<Phase>('splash');
  useEffect(() => {
    document.documentElement.classList.remove('dark');
  }, []);

  const handleSplashDone = useCallback(() => {
    const onboarded = localStorage.getItem(ONBOARDED_KEY);
    setPhase(onboarded ? 'app' : 'onboarding');
  }, []);

  const handleOnboardingDone = useCallback(() => {
    localStorage.setItem(ONBOARDED_KEY, String(Date.now()));
    setPhase('app');
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Pages légales et SEO — bypasse splash/onboarding */}
        <Route path="/confidentialite/" element={<PrivacyPage />} />
        <Route path="/conditions/" element={<TermsPage />} />
        <Route path="/trajet/:slug/" element={<TrajetPage />} />
        <Route path="/trajet/:slug" element={<TrajetPage />} />

        {/* App principale */}
        <Route
          path="/*"
          element={
            <>
              {phase === 'splash' && (
                <SplashScreen onDone={handleSplashDone} />
              )}
              {phase === 'onboarding' && (
                <OnboardingFlow onDone={handleOnboardingDone} />
              )}
              {phase === 'app' && (
                <>
<HomePage />
                  <Footer />
                  <InstallPrompt />
                  <CookieBanner />
                </>
              )}
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
